import moment from 'moment-timezone'
import momentDuration from 'moment-duration-format/lib/moment-duration-format'

momentDuration(moment)

export default moment



// WEBPACK FOOTER //
// ./src/helpers/moment.js